// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"520b507c","235":"663788e8","441":"d1af9f3f","777":"d6ab045b"}[chunkId] + ".chunk.js";
};